import { IntervalType as l } from "@ancon/wildcat-types";
import s from "./getTimezoneAdjustedServiceInterval.mjs";
import "moment";
import "../time/getTimeSpanParts.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
function A(c, e, i) {
  if (e.exception) {
    const { exception: t } = e;
    if (t.type === l.Normal) {
      const n = s(
        c,
        t,
        i.utcOffset()
      ), { openingTime: o, closingTime: r } = n;
      if (i.isBetween(o, r))
        return e.exception;
    }
  } else
    for (let t = 0; t < e.intervals.length; t += 1) {
      const n = e.intervals[t], o = s(
        c,
        n,
        i.utcOffset()
      ), { openingTime: r, closingTime: f } = o;
      if (i.isBetween(r, f))
        return n;
    }
  return null;
}
export {
  A as default
};
